import React, { useState, useEffect } from "react";
import { MdOutlineCheck } from "react-icons/md";
import { useLpStore } from "../../../store/useLiquidityPartner";
import _ from "lodash";


const StablePartnerCard = ({ val, lp }: { val: any; lp: any }) => {
  const setShowLpModal = useLpStore((state) => state.setShowLp);
  const setLp = useLpStore((state) => state.setLp);
  const activeLp = useLpStore((state) => state.activeLp);

  const setShowWallet = useLpStore((state) => state.setShowWallet);
  const setSelectedLpId = useLpStore((state) => state.setSelectedLpId);

  const handleState = () => {
    setShowLpModal(true);
  };

  const activeCard = activeLp
    ? "border-2 border-[#0eb683] shadow-md relative"
    : " h-20 border rounded-md flex items-center justify-between px-5 relative cursor-pointer ";

  return (
    <div
      key={val}
      onClick={() => {
        setSelectedLpId(lp.id);
        setShowWallet(true);
        setLp(lp);
      }}
      className={` ${activeCard} ${
        activeLp ? "bg-gradient-to-r from-[#fff] to-[#e3f8f1]" : null
      }  h-20 border rounded-md flex items-center justify-between px-5 relative cursor-pointer bg-clip-border  active:scale-100`}
    >
      <div className="flex items-center">
        <div>
          <h1 className="text-lg font-light text-[#030303] mt-1">{lp.name}</h1>
          <div className="text-[#696677] text-xs">
            <div>
              {/* <span>{}</span> */}
              {/* <span>{_.capitalize(lp.blockchain)}</span> */}
              {/* <span>{_.capitalize(lp.walletType)}</span> */}
            </div>
          </div>
        </div>
      </div>
      {activeLp ? (
        <div className="rounded-full w-5 h-5 bg-[#0eb683] flex items-center justify-center absolute top-6 right-6 ">
          <MdOutlineCheck size={24} fill="#fff" />{" "}
        </div>
      ) : null}
      {activeLp ? (
        <div className="absolute h-1 w-1 rounded-full bg-[#00D266]  top-1 right-1 shadow-lg animate-ping"></div>
      ) : (
        <div className="absolute h-[6px] w-[5px] rounded-full bg-slate-400  top-1 right-1 "></div>
      )}
    </div>
  );
};

export default StablePartnerCard;
